import './Header.css';
import React from "react";

function Header(props) {

    return (
        <div class="header">
        </div>
    )
}

export default Header;